export default "__VITE_ASSET__D2y62jYK__"